import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HTTP_CONTEXT_ENDPOINT } from '@core/const';
import { OCC_ENDPOINTS, OccUnitPricesResponse } from '@product/const';
import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OccProductService {
  constructor(
    private http: HttpClient,
    private occEndpointsService: OccEndpointsService,
  ) {}

  loadUnitPrices(productCode: string): Observable<OccUnitPricesResponse> {
    const url = this.occEndpointsService.buildUrl(OCC_ENDPOINTS.unitPrices, {
      urlParams: {
        productCode,
      },
    });

    return this.http.get<OccUnitPricesResponse>(url, {
      context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS.unitPrices),
    });
  }
}
